module.exports = __webpack_public_path__ + "static/media/TopDelivery_3.48916378.png";